import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { rebuildButtonAction, runTemplateOnInputs } from './utils';

/**
 * HOC that'll run template replacement on `MessageProps` fields of spotlight
 * messages and render the wrapped component.
 *
 * If any of the replacements fail with missing variables the component isn't
 * rendered and null is returned.
 *
 * The returned wrapped component accepts a `variables=` property which should
 * be a map of key to string value.
 *
 * This property isn't forwarded to the wrapped component
 *
 * @param TargetComponent<Props>
 * @returns {Component<Props & VariableProps>}
 */
export default function withVariables(TargetComponent) {
  // eslint-disable-next-line @repo/internal/react/no-class-components
  class WithVariables extends Component {
    render() {
      const props = runMessagePropsReplacement(this.props);
      if (!props) {
        return null;
      }
      return /*#__PURE__*/React.createElement(TargetComponent, props);
    }
  }
  _defineProperty(WithVariables, "displayName", `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`);
  return WithVariables;
}

/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */
function runMessagePropsReplacement(props) {
  const {
    variables,
    ...otherProps
  } = props;
  const {
    title,
    body,
    primaryText,
    primaryAction,
    secondaryText,
    secondaryAction
  } = props;
  const inputs = {
    title,
    body,
    primaryText,
    primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
    secondaryText,
    secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
  };
  const replacedInputs = runTemplateOnInputs(variables || {}, inputs);
  if (!replacedInputs) {
    return null;
  }
  const outputProps = {
    ...otherProps,
    title: replacedInputs.title,
    body: replacedInputs.body,
    primaryText: replacedInputs.primaryText,
    secondaryText: replacedInputs.secondaryText
  };
  if (primaryAction) {
    outputProps.primaryAction = rebuildButtonAction(replacedInputs.primaryActionUrl, primaryAction);
  }
  if (secondaryAction) {
    outputProps.secondaryAction = rebuildButtonAction(replacedInputs.secondaryActionUrl, secondaryAction);
  }
  return outputProps;
}